import React from "react";
import nico from "../../assets/splash-nico-hi.png";
import { connect } from "react-redux";
import { signIn } from "./redux/action";
import { Link } from "react-router-dom";

import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import { Card, CardImg, CardBody, CardTitle } from "reactstrap";
import blogStyle from "../Blogs/style";
import manifest from "../../manifest.json";
import { forgotPassword, verifyOTP } from "./redux/action";
import ChangeLoginChildOverlay from "../../global/ChangeLoginChildOverlay";
import { Clipboard } from "@capacitor/clipboard";
import { Capacitor } from "@capacitor/core";
import { getAuthToken } from "../../global/utils/fetch";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
      OTP: "",
      showOverlay: false,
    };
      this.interval = null;
  }

  componentDidMount() {
      this.writeToClipboard();
      this.interval = setInterval(() => {
        console.log("Interval");
        this.checkClipboard();
      }, 1 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  checkClipboard = async () => {
    if (document.hasFocus()) {
      console.log("Window is focused!");
      if (Capacitor.isNativePlatform()) {
        const { type, value } = await Clipboard.read();
        // console.log(`Got ${type} from clipboard: ${value}`);
        if (value && this.state.OTP != value) {
          this.setState({ ...this.state, OTP: value });
          clearInterval(this.interval);
        }
      } else {
        let value = await navigator.clipboard.readText();
        console.log("Value => ",value);
        if (value) {
          this.setState({ ...this.state, OTP: value });
          clearInterval(this.interval);
        }
      }
    } else {
      console.log("Window is not focused.");
    }
  };

  writeToClipboard = async () => {
    if (document.hasFocus()) {
      console.log("Window is focused!");
      if (Capacitor.isNativePlatform()) {
        await Clipboard.write({
          string: "",
        });
      } else {
        await navigator.clipboard.writeText("");
      }
    } else {
      console.log("Window is not focused.");
    }
    
  };

  keyPressed = (event) => {
    if (event.key === "Enter") {
      // console.log("set focus");
      const form = event.target.form;
      const index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 1].focus();
    }
  };
  handleChange = (event) => {
    const value = event.target.value;
    this.setState({ [event.target.name]: value });
    this.setState({ error: "" });
  };
  validate = () => {
    if (!this.state.OTP) {
      this.setState({ error: "Please Enter OTP" });
      return false;
    } else {
      return true;
    }
  };

  showChildChangeOption = () => {
    this.setState({ showOverlay: true }, () => {});
  };

  isMultipleChild = () => {
    console.log(
      "Multiple child : ",
      Array.isArray(this.props?.user.childList) &&
        this.props?.user.childList.length > 1
    );
    return (
      Array.isArray(this.props.user.childList) &&
      this.props?.user.childList.length > 1
    );
  };

  render() {
    const { error } = this.state;
    const { innerWidth: width, innerHeight: height } = window;
    return (
      <div>
        <ChangeLoginChildOverlay
          isOpen={this.state.showOverlay}
          toggle={(isOpen) => {
            this.setState({
              showOverLay: isOpen,
            });
          }}
          history={this.props.history}
        />
        <Card style={blogStyle.cardView}>
          <img
            className={height > 741 ? "" : "mr-auto ml-auto"}
            top="true"
            width={height < 741 ? "55%" : height < 900 ? "90%" : "100%"}
            src={nico}
            alt="Card image cap"
          />
          <CardBody>
            <CardTitle>
              <h5
                style={
                  height > 741
                    ? { fontFamily: "baloo" }
                    : { fontFamily: "baloo", fontSize: "1rem" }
                }
              >
                Enter OTP to your verify account
              </h5>
            </CardTitle>
            <Form style={height < 741 ? { lineHeight: "0.5rem" } : {}}>
              <FormGroup>
                <p
                  style={{
                    color: "red",
                    textAlign: "left",
                    fontFamily: "baloo",
                  }}
                >
                  {" OTP valid for 30 minutes only"}
                </p>
                <Input
                  type="number"
                  name="OTP"
                  placeholder="Enter OTP"
                  value={this.state.OTP}
                  onChange={(e) =>
                    this.setState({ OTP: e.currentTarget.value })
                  }
                  style={{ ...blogStyle.input }}
                  ref="OTP"
                />
              </FormGroup>

              <div style={height < 741 ? { marginTop: "0.5rem" } : {}}>
                <span
                  style={{
                    color: "black",
                    float: "right",
                    fontFamily: "baloo",
                    marginBottom: "0.5rem",
                    cursor: "pointer"
                  }}
                  onClick={() => this.props.login(this.props.phone , this.props.email,"")}
                >
                  Resend OTP
                </span>
              </div>

              {typeof this.state.error !== "undefined" && (
                <p style={{ color: "red", lineHeight: "1.2rem" }}>
                  {this.state.error}
                </p>
              )}
              <Button
                onClick={() => {
                  if (this.validate()) {
                    this.props.verifyOTP(this.state.OTP, (response) => {
                      // console.log("Response => ", response);
                      localStorage.setItem("auth_token", getAuthToken());
                      if (response && response.survey && response.survey.survey_id > 0) {
                        console.log("Redirecting to survey ");
                        this.props.history.replace({
                          pathname: `survey/${response.survey.survey_id}`,
                        });
                      } else {
                        if (this.isMultipleChild()) {
                          this.showChildChangeOption();
                        } else this.props.history.replace("/");
                      }
                    });
                  }
                }}
                style={blogStyle.button}
                size="lg"
                block
              >
                Verify
              </Button>
              <div style={height < 741 ? { marginTop: "0.5rem" } : {}}>
                <Link to={"/"}>
                  <span
                    style={{
                      color: "black",
                      float: "right",
                      fontFamily: "baloo",
                    }}
                  >
                    Cancel
                  </span>
                </Link>
              </div>
            </Form>
          </CardBody>
        </Card>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 10,
            alignItems: "center",
          }}
        >
          <h6
            style={{ fontFamily: "baloo", fontSize: 14 }}
          >{`${manifest.applicationName} v${manifest.version}`}</h6>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  phone: state.userState.phone,
  email: state.userState.email,
  user: state.userState.user,
});
const mapDispatchToProps = (dispatch) => ({
  verifyOTP: (otp, onSuccess) =>
    dispatch(verifyOTP(otp, false,false, onSuccess)),
  forgotPassword: (OTP) => dispatch(forgotPassword(OTP)),
  login: (phone,email,verify) => dispatch(signIn(phone,email,verify)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
//export default Login;
